import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, UntypedFormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { StatusService } from '../../../status/status.service';
import { SystemEventService } from './system-event.service';
import { LoaderComponent } from '../../../../../../../_base-shared/components/loader/loader.component';
import { SharedModule } from '../../../../_shared/shared.module';
import { SystemEventConfiguration } from '../../../../../../../_base-shared/models/System/SystemEventConfiguration';

@Component({
  selector:    'app-system-status-event-editor',
  templateUrl: './system-status-event-editor.component.html',
  styleUrls:   [],
  imports:     [
    SharedModule,
    LoaderComponent
  ],
  standalone:  true
})
export class SystemStatusEventEditorComponent implements OnInit, OnDestroy {
  public statuses            = [];
  public isLoading           = 0;
  public isSubmitting        = false;
  public configuration: SystemEventConfiguration;
  public form: FormGroup;
  public formActive: boolean = false;

  private subscriptions: Array<Subscription> = [];

  constructor(
    private statusService: StatusService,
    private systemEventService: SystemEventService,
    private fb: UntypedFormBuilder,
    private toastr: ToastrService,
    public translateService: TranslateService,
  ) {
  }

  ngOnInit(): void {
    this.getStatuses();
    this.getConfiguration();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
  }

  private getStatuses(): void {
    this.isLoading++;
    this.subscriptions.push(
      this.statusService.index({select_all: 1})
        .pipe(finalize(() => this.isLoading--))
        .subscribe({
          next: res => {
            this.statuses = res.data.filter(status => !!status.status_id);
          },
          error: err => {console.log(err)}
        })
    )
  }

  private getConfiguration(): void {
    this.isLoading++;
    this.subscriptions.push(
      this.systemEventService.index()
        .pipe(finalize(() => this.isLoading--))
        .subscribe({
          next: res => {
            this.configuration = res.data;
            this.buildForm();
          },
          error: err => {console.error(err)}
        })
    )
  }

  private buildForm(): void {
    this.isLoading++;
    this.form = this.fb.group({
      default_status: [this.configuration.default_status?.status_id],
      new_creditor:   [this.configuration.new_creditor?.status_id],
      sign_contract:  [this.configuration.sign_contract?.status_id],
      send_contract:  [this.configuration.send_contract?.status_id],
    });
    console.log(this.form.value);
    this.isLoading--;
    this.formActive = true;
  }

  public submitForm(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.isSubmitting = true;
    this.subscriptions.push(
      this.systemEventService.store(this.form.value)
        .pipe(finalize(() => this.isSubmitting = false))
        .subscribe({
          next:     () => {
            this.toastr.success(this.translateService.instant('CONFIG.system_event.config_saved'));
          }, error: () => {
            this.toastr.error(this.translateService.instant('SHARED.went_wrong'));
          }
        })
    )
  }
}
